@if (isMatMenu) {
  <button mat-menu-item
          data-test="dms-openCopyFolderModal-button"
          [ngClass]="btnClass"
          [matTooltip]="title"
          [matTooltipDisabled]="isMatMenu"
          (click)="openCopyFolderModal()">
    <i [hidden]="labelOnly" class="icon fa-fw fas fa-copy"></i>
    <label [hidden]="iconOnly" class="mb-0">{{ title }}</label>
  </button>
} @else {
  <sk-button [appearance]="iconOnly ? 'icon' : 'text'"
             data-test="dms-openCopyFolderModal-button"
             [color]="iconOnly ? 'unspecified' : 'primary'"
             [label]="!iconOnly ? title : ''"
             [matTooltip]="title"
             [matTooltipDisabled]="isMatMenu"
             (click)="openCopyFolderModal()">
    @if (iconOnly) {
      <i [hidden]="labelOnly" class="icon fa-fw fas fa-copy"></i>
    } @else {
      <ng-template buttonPrefix>
        <i [hidden]="labelOnly" class="icon fa-fw fas fa-copy"></i>
      </ng-template>
    }
  </sk-button>
}
